var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"padding":"10px 20px","max-height":"calc(100vh - 70px)","overflow-y":"auto"}},[_c('div',{staticStyle:{"display":"grid","grid-template-rows":"auto","grid-template-columns":"33% 33% 33%"}},_vm._l((_vm.systems),function(system){return _c('div',{key:system.id},[_c('system-herd-weight-card',{attrs:{"system":system}})],1)}),0)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ddf611a4","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/HerdsWeightView.vue
// module id = 2060
// module chunks = 25